import React, { createContext, useContext, FC, PropsWithChildren } from "react";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import ErrorPermissions from "src/Components/Error/ErrorPermissions";
import { useFetchPermissions } from "./useFetchPermissions";
import { IPermission } from "./permissions.models";

interface IPermissionsContext {
  permissions: IPermission[];
}

export const PermissionsContext = createContext<IPermissionsContext>({
  permissions: [],
});

export const PermissionsContextProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const { data: permissions, isLoading, isError } = useFetchPermissions();

  if (isError) {
    dynamicNotification(__("Nie udało się pobrać uprawnień"), "error");
    return <ErrorPermissions />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <PermissionsContext.Provider value={{ permissions: permissions || [] }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  const context = useContext(PermissionsContext);

  if (context === undefined) {
    throw new Error("PermissionsContext was used outside of its Provider");
  }

  return context;
};
